;(function (angular, _) {
  'use strict'

  angular
    .module('kilo.routes.entity.list')
    .controller('EntityListController', EntityListController)

  EntityListController.$inject = [
    // Angular
    '$q', '$state', '$window', '$scope',

    // Managers
    'BalanceManager', 'EntityManager', 'InvoiceManager',
    'QuoteManager', 'CreditNoteManager',

    // Services
    'UtilService', 'FilterSidebarService', 'ColumnService',
    'SelectionService', 'PreferencesService', 'FilterService',

    // Resolve
    'pagination', 'customFields'

  ]

  function EntityListController (
    // Angular
    $q, $state, $window, $scope,

    // Managers
    BalanceManager, EntityManager, InvoiceManager,
    QuoteManager, CreditNoteManager,

    // Services
    UtilService, FilterSidebarService, ColumnService,
    SelectionService, PreferencesService, FilterService,

    // Resolve
    pagination, customFields

  ) {
    var self = this

    self.$onInit = () => {
      _.extend(self, {

        // Attributes
        pagination: pagination,
        customFields: customFields,
        // Solde par client, lu par la cellule « balance » à la place de getBalance(entity)
        // (_.find sur toutes les balances, deux fois par cellule et par digest).
        // Vide tant que la requête des balances n'est pas revenue : même rendu qu'avec getBalance → undefined.
        balanceByClient: Object.create(null),
        sideBar: FilterSidebarService,
        selection: SelectionService.getSelection(),
        ColumnService: ColumnService,

        // Methods
        addCriteria: addCriteria,
        groupFind: FilterService.groupFind,
        getList: getList,
        sort: sort,
        searchClients: searchClients,
        searchClientsNumber: searchClientsNumber,
        searchAccounts: searchAccounts,
        searchSirets: searchSirets,
        searchBalances: searchBalances,
        searchCustomFieldText: searchCustomFieldText,
        getBalance: getBalance,
        getInvoices: getInvoices,
        getQuotes: getQuotes,
        dropColumn: dropColumn,
        isVisible: isVisible,
        newTab: newTab,
        isCompanyPrefsValid: isCompanyPrefsValid,
        saveColumns: saveColumns,
        resetColumns: resetColumns,
        clearSearch: clearSearch,
        isCustomField: isCustomField,
        go: go
      })

      // Colonnes visibles uniquement (dans l'ordre de self.columns), itérées par le template
      // à la place de self.columns + ng-if="isVisible(col.id)" (toutes les colonnes x N lignes à chaque digest).
      // self.columns est réaffecté (init, saveColumns, resetColumns, dropColumn) mais aussi muté en
      // place (splice de dropColumn, ColumnService.loadNewColumns sur le tableau des préférences) :
      // un seul $watchGroup, non profond, sur la référence du tableau + une signature id:visible.
      $scope.$watchGroup([
        () => self.columns,
        () => self.columns && self.columns.map(c => c.id + ':' + !!c.visible).join(',')
      ], updateVisibleColumns)
      // Index des clés de champs perso, lu par chaque cellule à la place de isCustomField(col.id)
      // (_.map de tous les champs perso par cellule et par digest). Recalculé si la liste est réaffectée.
      $scope.$watch(() => self.customFields, updateCustomFieldIds)

      init()
    }

    function init () {
      self.manager = EntityManager
      self.sideBar.init()
      self.ColumnService.init()
      PreferencesService.getPrefsFor('general').then(function (prefs) {
        self.prefs = prefs
        self.columns = UtilService.updateColumnList(ColumnService.getColumns('entity'), self.customFields, ColumnService.getDefaultColumns('entity'))
        if (prefs.hasOwnProperty('settings')) {
          if (_.get(prefs.settings.entityList, 'pagination')) {
            self.pagination.perPage = _.get(prefs.settings.entityList, 'pagination')
          }
          if (_.get(prefs.settings, 'sideBarVisible')) {
            self.sideBar.filterVisible = _.get(prefs.settings, 'sideBarVisible')
          }
        }
        self.selection.selectedData = []
        getList()
      })
    }

    function isCustomField (key) {
      return _.includes(_.map(self.customFields, 'key'), key)
    }

    function saveColumns () {
      self.prefs.settings.entityList.columns = self.columns
      self.prefs.save().then(function (data) {
        self.columns = ColumnService.getColumns('entity')
      })
    }

    function resetColumns () {
      self.prefs.settings.entityList.columns = UtilService.updateColumnList(ColumnService.getDefaultColumns('entity'), self.customFields, ColumnService.getDefaultColumns('entity'))
      self.prefs.save().then(function (data) {
        self.columns = ColumnService.getColumns('entity')
      })
    }

    function isCompanyPrefsValid () {
      return PreferencesService.isCompanyPrefsValid()
    }

    function go (entity) {
      $state.go('entity.show', { id: entity })
    }

    function newTab (id) {
      var url = $state.href('entity.show', { id: id })
      $window.open(url, '_blank')
    }

    function dropColumn (source, target) {
      var newIndex = _.findIndex(self.columns, { id: target })
      var oldIndex = _.findIndex(self.columns, { id: source })
      self.columns.splice(newIndex, 0, self.columns.splice(oldIndex, 1)[0])
      self.prefs.save().then(function () {
        self.columns = ColumnService.getColumns('entity')
      })
    }

    function sort (name) {
      this.reverse = (self.pagination.orderBy === name) ? !this.reverse : false
      self.pagination.orderBy = name
      self.pagination.reverse = this.reverse
      getList()
    }

    function searchClients (search) {
      if (search) {
        FilterService.searchClients(search, ['Organization', 'Agency', 'Contact']).then(function (data) {
          self.clients = data
        })
      }
    }

    function searchClientsNumber (search) {
      if (search) {
        FilterService.searchClientsNumber(search, ['Organization', 'Agency', 'Contact']).then(function (data) {
          self.clientsNumber = data
        })
      }
    }

    function searchAccounts (search) {
      if (search) {
        FilterService.searchAccounts(search, ['Organization', 'Agency', 'Contact']).then(function (data) {
          self.accounts = data
        })
      }
    }

    function searchSirets (search) {
      if (search) {
        FilterService.searchSirets(search, ['Organization', 'Agency', 'Contact']).then(function (data) {
          self.sirets = data
        })
      }
    }

    function searchBalances (search) {
      FilterService.searchBalances(search, ['Organization', 'Agency', 'Contact']).then((data) => {
        addCriteria('_id', { type: search, value: data })
      })
    }

    function searchCustomFieldText (search) {
      FilterService.searchCustomFieldText(search, ['Organization', 'Agency', 'Contact']).then((data) => {
        addCriteria('_id', { type: search, value: data })
      })
    }

    function clearSearch () {
      if (_.isEmpty(self.pagination.search)) return
      self.pagination.search = {}
      getList()
    }

    function getList () {
      self.pagination.search = FilterService.sanitizeSearchTree(self.pagination.search, true)
      self.pagination.save()
      self.loading = true

      var hasArchived = self.pagination.search && FilterService.hasArchivedCriteria(self.pagination.search)
      if (!hasArchived) {
        addCriteria('isArchived', { _id: 'archived', value: 'false' })
        return
      }

      var query = EntityManager
        .query({
          conditions: {
            'flags': { $ne: 'provider' }
          }
        })
        .select(['Organization', 'Agency', 'Contact'], '__t')
        .fields('type __t _id address defaultAddress label insensitive number account siret customFields')
        .populate('defaultAddress')
        .sort('insensitive')
        .paginate(self.pagination.toQueryOptions())

      if (_.get(self, 'pagination.search')) {
        query.setQuery(FilterService.parseQueryTree(self.pagination.search))
        // if (_.get(self, 'pagination.search.client')) {
        //   query.select(_.get(self, 'pagination.search.client._id'), '_id')
        // }
      }

      EntityManager.post(query).then(function (entityData) {
        self.entities = entityData.data
        self.pagination.totalElements = entityData.meta.total
        if (entityData.meta.total > 0 && !self.entities.length && self.pagination.currentPage >= 0) {
          pagination.currentPage = 0
          getList(pagination)
        }

        var balanceQuery = BalanceManager
          .query()
          .select(_.map(entityData.data, '_id'), 'client')
          .fields('client value')

        var invoiceQuery = InvoiceManager
          .query()
          .select(_.map(entityData.data, '_id'), 'client')
          .fields('_id status client')

        var quoteQuery = QuoteManager
          .query()
          .select(_.map(entityData.data, '_id'), 'client')
          .fields('_id status client')

        var creditNoteQuery = CreditNoteManager
          .query()
          .select(_.map(entityData.data, '_id'), 'client')
          .fields('_id status client')

        BalanceManager.post(balanceQuery).then(function (balanceData) {
          self.balances = balanceData.data
          self.balanceByClient = indexBalances(self.balances)
        })

        InvoiceManager.post(invoiceQuery).then(function (invoiceData) {
          self.invoices = invoiceData.data
          self.sortedInvoices = _.groupBy(self.invoices, 'client')
        })

        QuoteManager.post(quoteQuery).then(function (quoteData) {
          self.quotes = quoteData.data
          self.sortedQuotes = _.groupBy(self.quotes, 'client')
        })

        CreditNoteManager.post(creditNoteQuery).then(function (creditNoteData) {
          self.creditNotes = creditNoteData.data
          self.sortedCreditNotes = _.groupBy(self.creditNotes, 'client')
        })

        self.loading = false
      })
    }

    function addCriteria (key, value, negation) {
      if (value !== undefined && value !== null) {
        self.pagination.search = FilterService.addCriteria(self.pagination.search, key, value, negation)
        getList()
      }
    }

    function getBalance (entity) {
      var res = _.find(self.balances, function (b) {
        return b.client === entity._id
      })
      if (res) {
        return res.value
      }
    }

    function indexBalances (balances) {
      // Même résultat que getBalance : première balance trouvée pour le client, value telle quelle (0 compris)
      const byClient = Object.create(null)
      _.forEach(balances, function (b) {
        if (!(b.client in byClient)) {
          byClient[b.client] = b.value
        }
      })
      return byClient
    }

    function getInvoices (entity) {
      return _.filter(self.sortedInvoices, { 'client': entity._id })
    }

    function getQuotes (entity) {
      return _.filter(self.quotes, { 'client': entity._id })
    }

    function updateVisibleColumns () {
      self.visibleColumns = _.filter(self.columns, 'visible')
    }

    function updateCustomFieldIds () {
      // Objet sans prototype : un id de colonne comme 'constructor' ne doit pas être vu comme champ perso
      const ids = Object.create(null)
      _.forEach(self.customFields, function (field) {
        ids[field.key] = true
      })
      self.customFieldIds = ids
    }

    function isVisible (columnId) {
      if (!self.columns) {
        return
      }
      for (var i = 0; i < self.columns.length; i++) {
        if (self.columns[i].id === columnId) {
          return self.columns[i].visible
        }
      }
      return false
    }
  }
})(window.angular, window._)
